import branch from 'branch-sdk';
import { BRANCH_KEY } from 'config';

class BranchBridge {
  constructor(key) {
    this.key = key;
    branch.init(key, (err, data) => {
      console.error(err);
    });
  }

  sendSMS(mobile) {
    const phone = '+886' + mobile.substr(1, 9);
    const linkData = {
      tags: [],
      channel: 'Website',
      feature: 'Text-Me-The-App',
      data: {
        uri: 'autopassapp://open_main_page?need_login=false',
      },
    };
    const options = {};
    const callback = function (err, result) {
      if (err) {
        console.log(err);
      } else {
        console.log(result);
      }
    };
    branch.sendSMS(phone, linkData, options, callback);
  }
}

export default new BranchBridge(BRANCH_KEY);
